import styled from 'styled-components';
import { ProgressBar as ProgressBarBootstrap } from 'react-bootstrap';

import { Button, PaginationSelectGroup, Table } from '@/components/common';
import { SIDEBAR_DELAY } from '@/config/variables';
import { Completed } from '@/assets/icons';
import { media } from '@/styles/theme';
import { otherColors } from '@/styles/colors';

const Title = styled.div`
  display: flex;
  font-weight: 300;
  font-size: 20px;
  line-height: 1.4;
  color: #0a4599;

  transition: font-size ${SIDEBAR_DELAY};

  ${media.tablet} {
    font-size: 24px;
  }
`;

const NotMetText = styled(Title)`
  color: #ef4444;
  margin-left: 7px;
`;

const MetText = styled(Title)`
  color: #00af46;
  margin-left: 7px;
`;

const StyledButton = styled(Button)`
  width: 100%;

  ${media.tablet} {
    max-width: 140px;
  }
`;

const ProgressBar = styled(ProgressBarBootstrap)`
  height: 6px;
  margin-top: 7px;
  margin-right: 20px;
  border: 1px solid ${otherColors.light_grey_border};
`;

const ProgressBarMobile = styled(ProgressBarBootstrap)`
  width: 100%;
  height: 8px;
  margin-left: 45px;
  border: 1px solid ${otherColors.light_grey_border};
  background-color: #fff;
`;

const UnMetValueProgressBarMobile = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

const RequirementsMet = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 82px;
  padding: 15px 10px;
  background: #ecfdf5;

  border: 1px solid #d1fae5;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  border-radius: 8px;

  color: #047857;
  font-weight: bold;
  font-size: 14px;
`;

const RequirementsMetIcon = styled.div`
  height: 20px;
  width: 20px;
  background-image: url(${Completed});
  background-size: 15px;
  background-repeat: no-repeat;
  background-position: center;
`;

const RequirementsMetSmallScreenContianer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TableCell = styled(Table.Cell)`
  font-weight: 700;
  font-size: 12px;
`;

const StyledPagination = styled(PaginationSelectGroup)`
  min-width: 125px;
  margin-top: 8px;

  ${media.tablet} {
    width: 190px;
    margin-left: auto;
  }
`;

export {
  Title,
  NotMetText,
  MetText,
  StyledButton,
  ProgressBar,
  ProgressBarMobile,
  UnMetValueProgressBarMobile,
  RequirementsMet,
  RequirementsMetIcon,
  RequirementsMetSmallScreenContianer,
  TableCell,
  StyledPagination,
};
